import React, { useRef, useEffect } from "react";
import Header from "./Header";
import Body from "./Body";
import Footer from "./Footer";
import TableContainer from "@mui/material/TableContainer";
import { Fab, Paper } from "@mui/material";
import ToolBar from "./ToolBar";
import Table from "@mui/material/Table";

import { useState } from "react";
import LinearProgress from "@mui/material/LinearProgress";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import { Box } from "@mui/system";
import usePersistedState from "../../Hooks/usePersistedState";
import SendIcon from "@mui/icons-material/Send";
import { useLocation } from "react-router-dom";

function isNumeric(str) {
  if (typeof str != "string") return false; // we only process strings!
  return (
    !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str))
  ); // ...and ensure strings of whitespace fail
}

function sortByThenBy(a, b, thenBy, order) {
  if (order === "asc") {
    if (!a && !b) return thenBy || 0;
    if (!a) return -1;
    if (!b) return +1;

    if (typeof a === "number" || isNumeric(a)) {
      // console.log("number");

      return a - b || thenBy || 0;
    } else {
      return a.localeCompare(b) || thenBy || 0;
    }
  } else if (order === "desc") {
    if (!a && !b) return thenBy || 0;
    if (!a) return +1;
    if (!b) return -1;

    if (typeof a === "number" || isNumeric(a)) {
      // console.log("number");

      return b - a || thenBy || 0;
    } else {
      // console.log("other");

      return b.localeCompare(a) || thenBy || 0;
    }
  }
}

function DataTable(props) {
  const { name, columns, options, uniqueKey } = props;

  const [searchField, setSearchField] = useState("");
  const [displayColumns, setDisplayColumns] = usePersistedState(
    uniqueKey,
    [...columns] || []
  );
  const [sortBy, setSortBy] = useState([]);
  const [rowFilters, setRowfilters] = useState([]);
  const [editIndex, setEditIndex] = useState(false);
  const [rowCopy, setRowCopy] = useState(false);

  const location = useLocation();

  const element = useRef();

  useEffect(() => {
    // console.log(element);
    
    element.current.scrollTop = options?.scrollTop;
  }, [location.pathname]);

  const sorted = () => {
    const sortFunc = (a, b) => {
      let func = null;

      [...sortBy].reverse().forEach((item) => {
        func = `sortByThenBy(a["${item.column}"], b["${item.column}"], ${func}, "${item.order}")`;
      });

      return eval(func);
    };

    return [...props.rows].sort((a, b) => sortFunc(a, b));
  };

  const filteredColumns = displayColumns.filter((item) => {
    if (item.hasOwnProperty("display")) {
      return item.display;
    } else {
      return true;
    }
  });

  const filteredRows = sorted().filter((row) => {
    const array = Object.values(row).map((item) =>
      item?.toLowerCase?.()?.includes(searchField.toLowerCase?.())
    );

    return (
      rowFilters
        .map((item) =>
          item.values.map((item) => item.title).includes(row[item.column])
        )
        .every((item) => item === true) && array.includes(true)
    );
  });

  return (
    <>
      {options?.toolbar !== false && (
        <ToolBar
          searchField={searchField}
          setSearchField={setSearchField}
          name={name}
          rows={props.rows}
          columns={columns}
          displayColumns={displayColumns}
          setDisplayColumns={setDisplayColumns}
          rowFilters={rowFilters}
          setRowfilters={setRowfilters}
        />
      )}

      <Paper
        sx={{
          maxHeight: "calc(100% - 7px)",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          position: "relative",
        }}
        elevation={3}
        square
      >
        {options?.isLoading && <LinearProgress />}
        <TableContainer
          sx={{ height: "100%" }}
          ref={element}
          onScroll={(e) => {
            options?.onScroll?.(e);
          }}
        >
          <Table
            size="small"
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Header
              options={options}
              sortBy={sortBy}
              setSortBy={setSortBy}
              columns={filteredColumns}
            />

            <Body
              rows={filteredRows}
              filteredColumns={filteredColumns}
              columns={columns}
              options={options}
              editIndex={editIndex}
              setEditIndex={setEditIndex}
              rowCopy={rowCopy}
              setRowCopy={setRowCopy}
            />
          </Table>
        </TableContainer>
        {/* <Footer /> */}
        {options?.fob &&
          (options.editable !== false || options.new === true) && (
            <Fab
              sx={{
                position: "absolute",
                bottom: 20,
                right: 20,
                zIndex: 3000,
              }}
              color="primary"
              aria-label="add"
              onClick={(e) => {
                options?.fob(setEditIndex, setRowCopy);
              }}
            >
              <AddIcon />
            </Fab>
          )}

        {options?.saveAll &&
          (options.editable !== false || options.new === true) && (
            <Fab
              sx={{
                position: "absolute",
                bottom: 20,
                right: 20,
                zIndex: 3000,
              }}
              color="primary"
              aria-label="add"
              onClick={(e) => {
                options?.saveAll(setEditIndex, setRowCopy);
              }}
            >
              <SendIcon />
            </Fab>
          )}
      </Paper>

      <Box
        sx={{
          maxHeight: "calc(100% - 80px)",
          position: "relative",
          overflow: "visible",
        }}
      >
        {options?.SpeedDial && options.editable !== false && (
          <SpeedDial
            ariaLabel="SpeedDial basic example"
            direction="right"
            sx={{
              position: "absolute",
              bottom: 15,
              left: 15,
              zIndex: 3000,
            }}
            icon={<SpeedDialIcon />}
          >
            {options?.SpeedDial.actions?.map((action) => (
              <SpeedDialAction
                tooltipPlacement="top"
                sx={{ zIndex: 3000 }}
                key={action.name}
                icon={action.icon}
                tooltipTitle={action.name}
                // tooltipOpen={action.tooltipOpen}
                onClick={() => action.onClick(setEditIndex, setRowCopy)}
              />
            ))}
          </SpeedDial>
        )}
      </Box>
    </>
  );
}

export default DataTable;
